import role2Schema from '../../../assets/forms/role-2.form.json';
import role3Schema from '../../../assets/forms/role-3.form.json';
import role4Schema from '../../../assets/forms/role-120000.form.json';
import role5Schema from '../../../assets/forms/role-120100.form.json';
import role7Schema from '../../../assets/forms/role-130000.form.json';
import { SHEET_KEYS } from '../../models/sheet-keys';
import { WarnableControl } from './validators/warning-eval.helper';

/**
 * Schema controls (carrying `warnings` rules) for each warning-bearing sheet,
 * keyed by its FilingFormState state key.
 *
 * Used by `FilingFormStateService.updateSheetLevelStatus` to roll the live
 * FieldWarningService surface up into the sheet-level `hasSuggestedChanges`
 * flag (the red asterisk), so the editor matches the headless pure validators
 * which OR the same schema warnings into the submit-for-validation payload.
 *
 * Only sheets that actually declare `warnings` in their form schema appear here.
 * Every other sheet is absent and left untouched — including the calc-diff
 * monetary sheets (role 8/9/12/13/15/18/19), whose `hasSuggestedChanges` is
 * driven by the extracted-sum diff, not schema warnings.
 *
 * Roles 0 and 1 (filing prerequisites / filing info) were removed on
 * 2026-08-12: their only two rules — a "start date is more than 10 years old"
 * (`dateOlderThanYears`) and a "end date is in the future" (`dateInFuture`)
 * advisory on the current financial-year dates — were withdrawn from both form
 * schemas, so neither sheet can raise a schema warning any more. Re-declaring a
 * `warnings` block on either schema means re-adding its key here (and the
 * matching entry in `suggestion-capability.spec.ts`), otherwise the warning
 * would render inline but never reach the sheet-level asterisk.
 *
 * Keyed by `string` (the SHEET_KEYS values) rather than `keyof FilingFormState`
 * to avoid a circular import with filing-form-state.service.ts.
 */
export const WARNING_CONTROLS_BY_STATE_KEY: Readonly<
  Record<string, ReadonlyArray<WarnableControl>>
> = {
  [SHEET_KEYS.scopeOfFiling]: role2Schema.controls as unknown as WarnableControl[],
  [SHEET_KEYS.stockExchangeDisclosure]:
    role3Schema.controls as unknown as WarnableControl[],
  [SHEET_KEYS.directorsReport]: role4Schema.controls as unknown as WarnableControl[],
  [SHEET_KEYS.statementByDirectors]:
    role5Schema.controls as unknown as WarnableControl[],
  [SHEET_KEYS.auditorsReport]: role7Schema.controls as unknown as WarnableControl[],
};
